import { FishingArea } from "./FishingArea";

export class Traceability{
    origins?: string[];
    productionMethods?: string[];
    scientificNames?: string[];
    fishingTechniques?: string[];
    fishingAreas?: FishingArea[];
    productionTypes?: string[];

    fromJSON(obj: any) {
        this.origins = obj.origins;
        this.productionMethods = obj.productionMethods;
        this.scientificNames = obj.scientificNames;
        this.fishingTechniques = obj.fishingTechniques;
        this.fishingAreas = obj.fishingAreas;
        this.productionTypes = obj.productionTypes;
    }

    public equals(that: Traceability) {
        if (that == null) {
            return false;
        }

        if (this === that) {
            return true;
        }

        return this.origins === that.origins
            && this.productionMethods === that.productionMethods
            && this.scientificNames === that.scientificNames
            && this.fishingTechniques === that.fishingTechniques
            && this.fishingAreas === that.fishingAreas
            && this.productionTypes === that.productionTypes;
    }
}